module.exports = __webpack_public_path__ + "img/ep-X-dosis.733a96c4.jpg";